import * as React from "react"
import { Filter, LayoutDashboard, Radio, Settings2, UserPlus, Users, Workflow as WorkflowIcon } from "lucide-react"
import { useLocation } from "react-router-dom"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { ProjectSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"

type AppSidebarProject = {
  name: string
  slug: string
}

type AppSidebarProps = React.ComponentProps<typeof Sidebar> & {
  accountName: string
  user: { email: string }
  projects: AppSidebarProject[]
  currentProject: AppSidebarProject | null
  onSelectProject: (slug: string) => void
  onCreateProject: () => void
  onSignOut: () => void
}

export function AppSidebar({
  accountName,
  user,
  projects,
  currentProject,
  onSelectProject,
  onCreateProject,
  onSignOut,
  ...props
}: AppSidebarProps) {
  const location = useLocation()
  const projectBase = currentProject ? `/${currentProject.slug}` : "/onboarding"
  const resolvedAccountName = accountName || "Conta"
  const navMain = [
    {
      title: "Dashboard",
      url: projectBase,
      icon: LayoutDashboard,
      exact: true,
    },
    {
      title: "Contatos",
      url: `${projectBase}/contacts`,
      icon: Users,
      items: [
        {
          title: "Inscritos Push",
          url: `${projectBase}/subscribers`,
        },
        {
          title: "Contatos do Facebook",
          url: `${projectBase}/contacts`,
        },
      ],
    },
    {
      title: "Segmentos",
      url: `${projectBase}/segments`,
      icon: Filter,
    },
    {
      title: "Broadcasts",
      url: `${projectBase}/broadcasts`,
      icon: Radio,
    },
    {
      title: "Workflows",
      url: `${projectBase}/workflows`,
      icon: WorkflowIcon,
    },
    {
      title: "Configurações",
      url: `${projectBase}/settings`,
      icon: Settings2,
    },
    {
      title: "Membros",
      url: `${projectBase}/members`,
      icon: UserPlus,
    },
  ]

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <ProjectSwitcher
          accountName={resolvedAccountName}
          projects={projects}
          currentProject={currentProject}
          onSelect={onSelectProject}
          onCreate={onCreateProject}
        />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} activePath={location.pathname} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} onSignOut={onSignOut} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
